export default "__VITE_ASSET__D7RRj_sW__"